import { render, staticRenderFns } from "./DashboardBrandManager.vue?vue&type=template&id=c72a021c"
import script from "./DashboardBrandManager.vue?vue&type=script&lang=js"
export * from "./DashboardBrandManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports